var exports = {
  "KO": "Timeline_Item__SPOwOL",
  "qt": "Timeline_Item_inlineAvatars__agUydM",
  "Fb": "Timeline_Item_indent__x6ciCp",
  "_y": "Timeline_Item_groupStart__5RUdLa",
  "m4": "Octicon__kCvIds",
  "lc": "highlightedBadge__7bC8rT",
};

module.exports = exports;
